import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postCustomerSupportFaqSaveFaqHeaderapi } from "../../../../api/support/faq";
import { useModal } from "../../../../hooks";

export const usePostCustomerSupportFaqSaveFaqHeader = () => {
  const { handleModal } = useModal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => postCustomerSupportFaqSaveFaqHeaderapi(data),
    onSuccess: (res) => {
      if (res.code === "0000") {
        qc.invalidateQueries({
          queryKey: ["getCustomerSupportFaqReadFaqHeader"],
        });
        handleModal({
          isOpen: true,
          contents: "수정되었습니다.",
          type: "alert",
        });
      }
    },
    onError: (error) => {
      console.log("update error", error);
    },
  });
};
